(function () {
    'use strict';

    function siteConfigurationMainController() {

    }

    siteConfigurationMainController.$inject = [];

    angular.module('ecap.siteConfiguration').controller('siteConfigurationMainController', siteConfigurationMainController);
})();
